var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadebyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6",
    "data-name": "Group 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.037,
    height: 46.498,
    viewBox: "0 0 58.037 46.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 58.037,
    height: 46.498,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M165.069,94.691v9.184l21.136,21.136h8.7v-8.993L173.578,94.691Z",
    transform: "translate(-136.869 -78.514)",
    fill: "#c6e957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M8.45,0,6.056,6.365,3.662,0H1.168V13.568H3.662V7.462L4.9,11.173H7.193L8.45,7.423v6.145h2.494V0Z",
    transform: "translate(-0.968 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M85.6,7.383,87.8,3.013l2.195,4.37V8.6H85.6ZM86.442,0,82.91,6.784v6.784H85.6V11.193h4.39v2.375h2.694V6.784L89.135,0Z",
    transform: "translate(-68.746)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M0,96H4.21c3.751,0,5.986,2.295,5.986,6.784s-2.235,6.784-5.986,6.784H0Zm4.011,10.974c2.354,0,3.452-1.018,3.452-4.19s-1.1-4.19-3.452-4.19H2.694v8.38Z",
    transform: "translate(0 -79.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M84.078,96h9.178v2.594H86.772v2.1h4.489v2.594H86.772v3.691h6.684v2.594H84.078Z",
    transform: "translate(-69.714 -79.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M0,192H4.05c3.791,0,5.347,1.337,5.347,3.432a2.748,2.748,0,0,1-1.517,2.673,3.348,3.348,0,0,1,2.315,3.372c0,2.474-1.756,4.09-5.547,4.09H0Zm3.172,5.168c2.394,0,3.492-.2,3.492-1.377,0-1.157-1.1-1.4-3.492-1.4H2.693v2.773Zm.8,6.006c2.394,0,3.492-.519,3.492-1.816,0-1.277-1.1-1.8-3.492-1.8H2.693v3.611Z",
    transform: "translate(0 -159.199)",
    fill: "#c6e957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M85.883,192l1.916,5.048L89.714,192h2.973l-3.532,8.24v5.327H86.462V200.32L82.91,192Z",
    transform: "translate(-68.746 -159.199)",
    fill: "#c6e957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M170.387,209.921a5.317,5.317,0,1,0,5.318,5.318,5.318,5.318,0,0,0-5.318-5.318",
    transform: "translate(-136.869 -174.058)",
    fill: "#c6e957"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadebyLogo);
export default __webpack_public_path__ + "static/media/madeby_logo.0406eccb58a87e6dd1cc56e9414a9f56.svg";
export { ForwardRef as ReactComponent };